import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getCookie } from '@chilecompra/react-kit'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import ConfigProviderContainer from '../containers/ConfigProvider/ConfigProvider.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import PublishQuoteDialogContainer from '../containers/PublishQuoteDialog/PublishQuoteDialog.container'
import QuoteCreationHeadingContainer from '../containers/QuoteCreationHeading/QuoteCreationHeading.container'
import QuoteErrorDraftDialog from '../containers/QuoteErrorDraftDialog/QuoteErrorDraftDialog.container'
import QuoteNotification from '../containers/QuoteNotification/QuoteNotification.container'
import QuoteRequestPublishedErrorDialogContainer from '../containers/QuoteRequestPublishedErrorDialog/QuoteRequestPublishedErrorDialog.container'
import QuoteSaveDraftDialog from '../containers/QuoteSaveDraftDialog/QuoteSaveDraftDialog.container'
import QuoteStepTwoContainer from '../containers/QuoteStepTwo/QuoteStepTwo.container'

import routes from '../config/settings/routes'
import QuoteStepTwoMoreInfoDialog from '../containers/QuoteStepTwo/QuoteStepTwo.moreInfoDialog'

/**
 * The QuoteStepTwo's page.
 */
const QuoteStepTwo = () => {
  const navigate = useNavigate()

  const heading = {
    breadcrumbs: [
      {
        text: 'Escritorio',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Compra ágil',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Crear formulario'
      }
    ],
    step: 'PASO 2 DE 2',
    title: 'Crear Compra Ágil',
    description:
      'Una vez publicada, esta compra estará disponible para la participación de las Empresas de Menor Tamaño (EMT).',
    disclaimers: [<QuoteNotification key="cancelled-auto" />]
  }

  return (
    <AuthorizationProviderContainer>
      <ConfigProviderContainer>
        <ProtectByAccessToken>
          <BrandLayout featured={<QuoteCreationHeadingContainer {...heading} />}>
            <QuoteStepTwoContainer />
            <QuoteSaveDraftDialog />
            <QuoteErrorDraftDialog />
            <PublishQuoteDialogContainer />
            <QuoteRequestPublishedErrorDialogContainer />
            <OnboardingDialogContainer />
            <QuoteStepTwoMoreInfoDialog />
          </BrandLayout>
        </ProtectByAccessToken>
      </ConfigProviderContainer>
    </AuthorizationProviderContainer>
  )
}

export default QuoteStepTwo
